// extracted by mini-css-extract-plugin
export default {"select":"select_select__Jzc+Y","bg":"select_bg__LbjMs","dropdown":"select_dropdown__5xCHP","hidden":"select_hidden__CWcV1"};